<ngb-alert *ngIf="(isOnline | async) === false" [dismissible]="false">
  Connection lost. Attempting to reconnect...
</ngb-alert>
<ngb-alert *ngIf="showErrorBar && (isOnline | async) === true && errors && errors.length > 0" [dismissible]="true">
  Looks like
  <span *ngIf="errors.length === 1"> the {{ errors[0].affectedAPI.toString() }} API is</span>
  <span *ngIf="errors.length > 1">
    the following APIs:
    <span *ngFor="let error of errors; let i = index"
      >{{ error.affectedAPI.toString() }}
      <span *ngIf="i <= errors.length">, </span>
    </span>
    are
  </span>
  experiencing problems.
</ngb-alert>
